import {
  DiscountType,
  SubjectType,
} from '../../../../../../../shared/__generated__/globalSPATypes';

import { messages } from './messages';

export const getDiscountWithSymbol = (
  discountType: DiscountType,
  value: number
) =>
  ({
    // In future there is open possibility for other DiscountTypes
    [DiscountType.Percentage]: `${value}%`,
  }[discountType]);

export const subjectTypeMessages: Record<
  SubjectType,
  { id: string; defaultMessage: string }
> = {
  [SubjectType.BrandDiscount]: messages.brandDiscount,
  [SubjectType.CategoryDiscount]: messages.categoryDiscount,
};
